import { Product } from "src/screens/app/cart/cart-preview";

interface Props {
  product: Product;
  startDate: Date;
  endDate: Date;
  referenceString: string;
  prenom: string;
  nom: string;
}
export const EmailProductCard = ({
  product,
  startDate,
  endDate,
  referenceString,
  prenom,
  nom,
}: Props) => {
  return (
    <div>
      <div style={{ borderRadius: "0.75rem", overflow: "hidden", flexGrow: 1 }}>
        {/* Header */}
        <div
          style={{
            backgroundColor: "#007398",
            padding: "1rem",
            display: "flex",
            gap: "0.75rem",
            alignItems: "center",
          }}
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "40px", height: "40px" }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 0H32C34.12 0 36.16 0.84 37.66 2.34C39.16 3.84 40 5.88 40 8V32C40 34.12 39.16 36.16 37.66 37.66C36.16 39.16 34.12 40 32 40H8C5.88 40 3.84 39.16 2.34 37.66C0.84 36.16 0 34.12 0 32V8C0 5.88 0.84 3.84 2.34 2.34C3.84 0.84 5.88 0 8 0ZM10 20C10 14.4797 14.4797 10 20 10C25.5203 10 30 14.4797 30 20C30 25.5203 25.5203 30 20 30C14.4797 30 10 25.5203 10 20ZM11.9029 20C11.9029 24.4698 15.5302 28.0971 20 28.0971C24.4698 28.0971 28.0971 24.4698 28.0971 20C28.0971 15.5302 24.4698 11.9029 20 11.9029C15.5302 11.9029 11.9029 15.5302 11.9029 20ZM24.5788 19.0684C24.7572 19.1477 24.9158 19.2864 25.0248 19.445C25.1338 19.6135 25.2032 19.8117 25.223 20.0099C25.2329 20.2973 25.1338 20.5748 24.9356 20.783H24.9455C24.8563 20.8821 24.7374 20.9613 24.6085 21.0109C24.4797 21.07 24.331 21.09 24.1923 21.09H21.0406V24.1923C21.0406 24.331 21.0208 24.4599 20.9613 24.5887C20.9118 24.7175 20.8325 24.8266 20.7334 24.9257C20.6343 25.0248 20.5253 25.1041 20.3964 25.1635C20.1388 25.2725 19.8414 25.2725 19.5837 25.1635C19.4549 25.1041 19.3459 25.0248 19.2468 24.9257C19.0486 24.7275 18.9296 24.4599 18.9296 24.1824V21.0803H15.8672C15.7284 21.0803 15.5798 21.0505 15.4509 20.9911C15.1933 20.8722 14.995 20.664 14.8761 20.4063C14.8167 20.2775 14.7869 20.1388 14.7869 20C14.7869 19.8612 14.8167 19.7225 14.8761 19.5937C14.9257 19.4648 15.005 19.3459 15.114 19.2567C15.3122 19.0684 15.5699 18.9594 15.8474 18.9594H18.9495V15.8672C18.9395 15.5897 19.0287 15.3221 19.217 15.114C19.4054 14.9058 19.663 14.7869 19.9405 14.7671C20.0793 14.7572 20.218 14.777 20.3469 14.8266C20.4757 14.8761 20.5947 14.9554 20.6938 15.0545C20.8028 15.1437 20.8821 15.2527 20.9415 15.3816C21.001 15.5104 21.0307 15.6492 21.0307 15.7879V18.9594H24.1328C24.2914 18.9693 24.44 18.999 24.5788 19.0684Z"
              fill="#F3F3F4"
            ></path>
          </svg>
          <div style={{ fontWeight: "bold", color: "white" }}>
            {product.name}
          </div>
          <div
            style={{
              marginLeft: "auto",
              color: "white",
              fontWeight: "bold",
              fontSize: "larger",
            }}
          >
            {product.price}
          </div>
        </div>
        {/* Body */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "0 0 0.75rem 0.75rem",
            borderTop: "0px",
            border: "1px solid #e4e3e3",
            cursor: "pointer",
            padding: "1rem",
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              flex: 1,
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              <div
                style={{
                  color: "gray",
                }}
              >
                Valable du
              </div>
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                {new Intl.DateTimeFormat("fr-FR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }).format(startDate)}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              <div
                style={{
                  color: "gray",
                }}
              >
                Valable au
              </div>
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                {new Intl.DateTimeFormat("fr-FR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }).format(endDate)}
              </div>
            </div>
            <div
              style={{
                background: "#F7F6F3",
                borderRadius: "50px",
                padding: "10px 15px",
                maxWidth: "fit-content",
                marginTop: "10px",
                fontWeight: 600,
              }}
            >
              {prenom} {nom}
            </div>
          </div>
          <div
          style={{
            width: "30%"
          }}
          >
            <div
              style={{
                padding: "0px 10px",
                border: "0px",
                borderLeft: "1px solid #e4e3e3",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "20px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      color: "gray",
                    }}
                  >
                    Référence
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "larger",
                    }}
                  >
                    {referenceString}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      color: "gray",
                    }}
                  >
                    Nom
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "larger",
                      maxWidth: "70px",
                      overflow: "hidden",
                      textAlign: "start",
                      whiteSpace: "wrap",
                      textWrap: "wrap",
                    }}
                  >
                    {nom}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
